import {ENDPOINT_MERCHANT_SALES_NOTIF_GET, ENDPOINT_MERCHANT_SALES_NOTIF_SET} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequest,
} = require('../ws');


export const DEFAULT_SALES_NOTIFICATION = {
  email: '',
  enabled: false,
};
export const mockSalesNotification$ = new Emitter(DEFAULT_SALES_NOTIFICATION);
const {
  getValue,
} = mockSalesNotification$;

export function apiSalesNotificationSet(params) {
  if (process.env.MOCK) {
    mockSalesNotification$.set(params);
    return CancelablePromise.delay(500, getValue());
  }
  return apiRequest(ENDPOINT_MERCHANT_SALES_NOTIF_SET, {
    info: params,
  });
}
export function apiSalesNotificationGet(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, getValue());
  }
  return apiRequest(ENDPOINT_MERCHANT_SALES_NOTIF_GET, params).then('info');
}
